<!-- Benutzerverwaltung / Neuen Benutzer anlegen -->
<div class="gridContainer">

    <h1 class="goBack" (click)="goBack()">Benutzerverwaltung</h1>

    <h2>Neuen Benutzer anlegen</h2>

    <div class="gridContainer formGrid fitGrid">

        <div class="row">
            <div class="cell grid-25 alignr">
                <label for="vorname">Vorname:</label>
            </div>
            <div class="cell grid-50">
                <input id="vorname"
                       type="text"
                       name="f_benutzer_vorname"
                       placeholder="Vorname"
                       [(ngModel)]="model.vorname.value"
                       [class.error]="model.vorname.valid === false"
                       (blur)="validateField(model.vorname)"
                       (keyup)="onFieldKeyUp($event)">
                @if (model.vorname.valid === false) {
                    <div
                        class="errorMessage"
                        [innerHTML]="model.vorname.errorMsg"></div>
                }
            </div>
            <div class="cell grid-25">
            </div>
        </div>

        <div class="row">
            <div class="cell grid-25 alignr">
                <label for="nachname">Name:</label>
            </div>
            <div class="cell grid-50">
                <input id="nachname"
                       type="text"
                       name="f_benutzer_name"
                       placeholder="Name"
                       [(ngModel)]="model.nachname.value"
                       [class.error]="model.nachname.valid === false"
                       (blur)="validateField(model.nachname)"
                       (keyup)="onFieldKeyUp($event)">
                @if (model.nachname.valid === false) {
                    <div
                        class="errorMessage"
                        [innerHTML]="model.nachname.errorMsg"></div>
                }
            </div>
            <div class="cell grid-25">
            </div>
        </div>

        <div class="row">
            <div class="cell grid-25 alignr">
                <label for="email">E-Mail-Adresse:</label>
            </div>
            <div class="cell grid-50">
                <input id="email"
                       type="text"
                       name="f_benutzer_email"
                       placeholder="E-Mail-Adresse"
                       [(ngModel)]="model.email.value"
                       [class.error]="model.email.valid === false"
                       (blur)="validateField(model.email)"
                       (keyup)="onFieldKeyUp($event)">
                @if (model.email.valid === false) {
                    <div
                        class="errorMessage"
                        [innerHTML]="model.email.errorMsg"></div>
                }
            </div>
            <div class="cell grid-25">
            </div>
        </div>

        <div class="row">
            <div class="cell grid-25 alignr">
                <label for="emailConfirm">E-Mail-Adresse wiederholen:</label>
            </div>
            <div class="cell grid-50">
                <input id="emailConfirm"
                       type="text"
                       name="f_benutzer_email_wierholen"
                       placeholder="E-Mail-Adresse wiederholen"
                       [(ngModel)]="model.emailConfirm.value"
                       [class.error]="model.emailConfirm.valid === false"
                       (blur)="validateField(model.emailConfirm)"
                       (keyup)="onFieldKeyUp($event)">
                @if (model.emailConfirm.valid === false) {
                    <div
                        class="errorMessage"
                        [innerHTML]="model.emailConfirm.errorMsg"></div>
                }
            </div>
            <div class="cell grid-25">
            </div>
        </div>

        <div class="row trenner">
        </div>

        <div class="row">
            <div class="cell grid-25">
                <elem-button buttonRole="TERTIARY" class="expand" (click)="goBack()">
                    Abbrechen
                </elem-button>
            </div>
            <div class="cell grid-50">
            </div>
            <div class="cell grid-25">
                <elem-button buttonRole="PRIMARY"
                             class="expand"
                             [disabled]="nutzerAnlegenBlockiert()"
                             (click)="benutzerAnlegen()">
                    Benutzer anlegen
                </elem-button>
            </div>
        </div>

    </div>

</div>
